// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inst-container {
  container-type: inline-size;
  /*min-width: 768px;*/
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Content wrapper for flex layout */
.inst-container .inst-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

/* scrollable table container */
.inst-container .inst-table-container {
  flex: 1 1 auto;
  margin-top: 20px;
  min-height: 0;
}

.inst-container .inst-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.inst-container .inst-table thead th {
  box-shadow: inset 0 -1px 0 0 var(--border-line);
  text-align: right;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: bottom;
  white-space: nowrap;
}
.inst-container .inst-table thead th:nth-child(1) {
  /*padding:0px !important;    */
}
.inst-container .inst-table thead th:first-child {
  width: 22px;
  box-shadow: none;
}

.inst-container .inst-table thead th:last-child {
  width: 22px;
  box-shadow: none;
}

.inst-container .inst-table tbody td {
  vertical-align: middle;
  box-shadow: inset 0 -1px 0 0 var(--border-tertiary, #e0e0e0);
}

.inst-container .inst-table tbody td:first-child {
  width: 22px;
  border: none;
}

.inst-container .inst-table tbody td:last-child {
  width: 22px;
  border: none;
}
/*.inst-container .inst-table tbody tr:nth-child(2n) {
    background-color: #EFEFEF;
}    */

/* Table header styles */
.inst-table-header {
  padding: 8px 0;
  text-align: left;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-size: 16px;
  color: var(--text-subheader);
}

.inst-currency-label {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.inst-container .inst-table thead th.inst-table-header-year {
  text-align: right;
  padding: 0px 8px 8px 8px;
  min-width: 80px;
  max-width: 100px;
}

.inst-container .inst-table thead th.inst-table-header-label {
  text-align: left;
  padding: 0px 8px 8px 8px;
  min-width: 180px;
  max-width: 180px;
}

.inst-header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.inst-header-fy {
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: var(--text-subheader);
}

.inst-header-date {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-subheader);
}

/* Table body styles */
.inst-container .inst-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  text-align: right;
  font-size: 16px;
  padding: 0;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  box-sizing: border-box;
}

.inst-container .inst-table tbody td.inst-table-label-cell {
  text-align: left;
  padding-left: 8px;
  min-width: 180px;
  max-width: 180px;
}

.inst-container .inst-table tbody td.inst-table-cell {
  text-align: right;
  padding: 0 8px 0 0;
  min-width: 100px;
  max-width: 100px;
}

.inst-label-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.inst-expand-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  flex-shrink: 0;
  color: var(--accent-primary);
  path {
    fill: var(--accent-primary);
  }
}

.inst-expand-icon.expanded {
  transform: rotate(0deg);
}

.inst-label-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
}

.inst-indented-label {
  font-size: 16px;
  line-height: 24px;
  padding-left: 32px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inst-cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /*gap: 2px;*/
  padding: 8px 0;
}

.inst-cell-value {
  font-size: 16px;
  line-height: 18px;
  color: var(--text-primary);
  height: 24px;
}

.inst-cell-growth {
  font-size: 14px;
  line-height: 100%;
  font-weight: 400;
  height: 16px;
}

.inst-cell-growth.positive {
  color: var(--text-up-color);
}

.inst-cell-growth.negative {
  color: var(--text-down-color);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/IncomeStatementWidget/IncomeStatementWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;;MAEM;;AAEN,wBAAwB;AACxB;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".inst-container {\n  container-type: inline-size;\n  /*min-width: 768px;*/\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content wrapper for flex layout */\n.inst-container .inst-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n}\n\n/* scrollable table container */\n.inst-container .inst-table-container {\n  flex: 1 1 auto;\n  margin-top: 20px;\n  min-height: 0;\n}\n\n.inst-container .inst-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.inst-container .inst-table thead th {\n  box-shadow: inset 0 -1px 0 0 var(--border-line);\n  text-align: right;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  padding: 0;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: bottom;\n  white-space: nowrap;\n}\n.inst-container .inst-table thead th:nth-child(1) {\n  /*padding:0px !important;    */\n}\n.inst-container .inst-table thead th:first-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.inst-container .inst-table thead th:last-child {\n  width: 22px;\n  box-shadow: none;\n}\n\n.inst-container .inst-table tbody td {\n  vertical-align: middle;\n  box-shadow: inset 0 -1px 0 0 var(--border-tertiary, #e0e0e0);\n}\n\n.inst-container .inst-table tbody td:first-child {\n  width: 22px;\n  border: none;\n}\n\n.inst-container .inst-table tbody td:last-child {\n  width: 22px;\n  border: none;\n}\n/*.inst-container .inst-table tbody tr:nth-child(2n) {\n    background-color: #EFEFEF;\n}    */\n\n/* Table header styles */\n.inst-table-header {\n  padding: 8px 0;\n  text-align: left;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-size: 16px;\n  color: var(--text-subheader);\n}\n\n.inst-currency-label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.inst-container .inst-table thead th.inst-table-header-year {\n  text-align: right;\n  padding: 0px 8px 8px 8px;\n  min-width: 80px;\n  max-width: 100px;\n}\n\n.inst-container .inst-table thead th.inst-table-header-label {\n  text-align: left;\n  padding: 0px 8px 8px 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.inst-header-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.inst-header-fy {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-subheader);\n}\n\n.inst-header-date {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--text-subheader);\n}\n\n/* Table body styles */\n.inst-container .inst-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  text-align: right;\n  font-size: 16px;\n  padding: 0;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  box-sizing: border-box;\n}\n\n.inst-container .inst-table tbody td.inst-table-label-cell {\n  text-align: left;\n  padding-left: 8px;\n  min-width: 180px;\n  max-width: 180px;\n}\n\n.inst-container .inst-table tbody td.inst-table-cell {\n  text-align: right;\n  padding: 0 8px 0 0;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.inst-label-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.inst-expand-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  flex-shrink: 0;\n  color: var(--accent-primary);\n  path {\n    fill: var(--accent-primary);\n  }\n}\n\n.inst-expand-icon.expanded {\n  transform: rotate(0deg);\n}\n\n.inst-label-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  max-width: 100%;\n}\n\n.inst-indented-label {\n  font-size: 16px;\n  line-height: 24px;\n  padding-left: 32px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.inst-cell-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  /*gap: 2px;*/\n  padding: 8px 0;\n}\n\n.inst-cell-value {\n  font-size: 16px;\n  line-height: 18px;\n  color: var(--text-primary);\n  height: 24px;\n}\n\n.inst-cell-growth {\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 400;\n  height: 16px;\n}\n\n.inst-cell-growth.positive {\n  color: var(--text-up-color);\n}\n\n.inst-cell-growth.negative {\n  color: var(--text-down-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
